<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)"
      @keydown.esc="$emit('updateDialog', false)" max-width="1000px" transition="dialog-bottom-transition">
      <template v-slot:activator="{ props }">
        <v-btn flat class="mb-3 btn-second" v-bind="props" @click="$emit('updateDialog', true)">{{ button_name
        }}</v-btn>
      </template>

      <v-card>
        <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-6">
                <v-text-field label="Codigo*" maxlength="3" counter="3" v-model="item.code" :rules="[rules.required, rules.max3Length]"
                  :disabled="disabled"></v-text-field>

                <v-text-field label="Nombre*" v-model="item.name" :disabled="disabled"
                  :rules="[rules.required]"></v-text-field>

                <v-text-field label="Direccion" v-model="item.address" :disabled="disabled" @blur="onInputBlur"></v-text-field>

                <v-text-field label="Ciudad" v-model="item.city" :disabled="disabled" @blur="onInputBlur"></v-text-field>

                <div class="row">
                  <div class="col-md-5">

                    <v-text-field label="Código Postal*" v-model="item.postal_code" :disabled="disabled"
                      :rules="[rules.required]" @blur="onInputBlur"></v-text-field>
                  </div>
                  <div class="col-md-7">
                    <v-combobox v-model="item.provincia" name="provincia" item-title="name" item-value="id"
                      :items="provincias" label="Provincia*" autocomplete="off" :disabled="disabled"
                      :rules="[rules.requiredComboBox]" clearable @blur="onInputBlur"></v-combobox>
                </div>
                </div>

              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <v-text-field label="Latitud" v-model="item.lat" :disabled="disabled"
                      readonly></v-text-field>
                  </div>
                  <div class="col-md-6">
                    <v-text-field label="Longitud" v-model="item.lng" :disabled="disabled"
                      readonly></v-text-field>
                  </div>
                </div>

                <Maps ref="mapaRef" :lat="item.lat" :lng="item.lng" :address="item.address" :location="item.city"
                  :postal_code="item.postal_code" :provincia="item.provincia" :disabled="disabled"
                  @coordinates-updated="onCoordinatesUpdated" />
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :loading="loading" v-if="!disabled">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import ValidMixin from "@/mixins/ValidMixin.vue";
import Maps from "@/components/Maps.vue";

export default {
  components: {
    Maps
  },
  mixins: [ValidMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
  },
  data() {
    return {
      show: false,
      disabled: false,
      provincias: [],
      loading: false,
      name: "",
      item: {
        id: "",
        name: "",
        code: "",
        provincia: null,
        address: "",
        city: "",
        lng: null,
        lat: null,
        postal_code: ""
      },
      defaultItem: null,
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.disabled = this.formBtn == "";

        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }

        if (this.editItem != null && this.editItem.id > 0) {
          this.item = JSON.parse(JSON.stringify(this.editItem));
        } else {
          if (this.defaultItem != null) this.item = JSON.parse(JSON.stringify(this.defaultItem));
        }
      }
    },
  },
  mounted() {
    this.loadProvincias();
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    onInputBlur() {
    // cuando cualquier input pierde el foco,
    // avisamos al hijo
      this.$refs.mapaRef.handleInputsBlur();
    },
    onCoordinatesUpdated({ lat, lng }) {
      this.item.lat = lat;
      this.item.lng = lng;
    },
    loadProvincias() {
      generalService
        .filter({}, Constant.SECTION_PROVINCIAS)
        .then((response) => {
          this.provincias = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    createItem() {
      if (this.loading) return;

      if (this.valid) {
        this.loading = true;

        var data = {
          id: this.item.id,
          name: this.item.name,
          code: this.item.code,
          provincia: { id: this.item.provincia.id },
          address: this.item.address,
          city: this.item.city,
          postal_code: this.item.postal_code,
          lat: this.item.lat,
          lng: this.item.lng
        };

        if (this.item.id > 0) {
          this.service
            .update(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("El " + this.modal_title + " se modifico correctamente.");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((response) => {
              this.toast.error(response.msg);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.service
            .create(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("El " + this.modal_title + " se creo correctamente");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((e) => {
              this.toast.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
  },
};
</script>
